import { render, staticRenderFns } from "./previewQuestion.vue?vue&type=template&id=1ecc6692&scoped=true"
import script from "./previewQuestion.vue?vue&type=script&lang=js"
export * from "./previewQuestion.vue?vue&type=script&lang=js"
import style0 from "./previewQuestion.vue?vue&type=style&index=0&id=1ecc6692&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecc6692",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ecc6692')) {
      api.createRecord('1ecc6692', component.options)
    } else {
      api.reload('1ecc6692', component.options)
    }
    module.hot.accept("./previewQuestion.vue?vue&type=template&id=1ecc6692&scoped=true", function () {
      api.rerender('1ecc6692', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/curriculum-manage/previewQuestion.vue"
export default component.exports